<div class="mt-filter filter-machine-type">
    <div class="title">
        <span class="label">{{ "machine type" | lang }}</span>
        <span *ngIf="filter.required" class="mandatory">*</span>
    </div>

    <div class="filter">
        <app-dropdown-selector
            [isDisabled]="
                filter.uniqueSelection
                    ? true
                    : false || filter.isForMtv
                    ? true
                    : false
            "
            label=""
            [items]="machineTypes"
            bindLabel="name"
            bindValue="machineTypeId"
            [multiselect]="filter.multiselect ? true : false"
            [allSelectedOption]="filter.multiselect ? true : false"
            [ngModel]="selectedOption"
            (ngModelChange)="changeSelectedOption($event)"
        >
        </app-dropdown-selector>
    </div>
</div>
